<template>
  <div v-show="showTabNumber != 100">

    <!-- 목록 시작 -->
    <md-card>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid ref="presidencyBrdGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @response="response"
        ></grid>

      </md-card-content>

      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "presidencyBrdListComp",

  props: {
    showTabNumber : {
      type: Number,
      default: 1
    }
  },

  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      presidencyCd : null,
      PresiLevelCd : null,
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    sendQuery (presidencyCd, PresiLevelCd){
      if(PresiLevelCd < 10){// 탭 순서와 레벨을 같게 함.
        PresiLevelCd = '0'+ PresiLevelCd;
      }
      this.presidencyCd = presidencyCd ? presidencyCd : this.presidencyCd;
      this.PresiLevelCd = PresiLevelCd ? PresiLevelCd : this.PresiLevelCd;
      let params = {
        "presidencyCd" : this.presidencyCd,
        "presiLevelCd" : this.PresiLevelCd
      };
      this.$refs.presidencyBrdGrid.invoke("readData", 1, params);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_PRESIDENCY_BRD_LIST, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.presidencyBrdGrid;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo', align : 'center', sortable: true},
          {header: '교우명', name: 'memberHnm', align : 'center', sortable: true},
          {header: '단과대학', name: 'collegeNm', align : 'center', sortable: true},
          {header: '학과', name: 'classNm', sortable: true},
          {header: '학번', name: 'hakbun', align : 'center', sortable: true},
          {header: '직장명', name: 'companyNm', sortable: true},
        ];
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.presidencyBrdGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.presidencyBrdGrid.invoke("refreshLayout");
    },
    getCheckedRows () {
      return this.$refs.presidencyBrdGrid.invoke('getCheckedRows');
    }
  }
};
</script>

<style lang="css" scoped>
</style>